import { useContext } from 'react';
import { RolePageContext, RolePageContextProvider, RolePageContextProps } from './RolePageContext';

const useRolePageContext = () => useContext(RolePageContext);

export { useRolePageContext, RolePageContextProvider, RolePageContextProps };
